import React, { PureComponent } from 'react';
import { get } from 'lodash';
import ModifierInputList from './ModifierInputList';
import { getSelectedPizzaCreatorModifiers } from './utils';

class PizzaCreatorModifiers extends React.Component {
  componentDidMount() {
    switch (this.props.scrollType) {
      case 'parent':
        document.getElementsByClassName(
          'addEditItemPopup'
        )[0].scrollTop = this.props.scrollBack;
        break;
      default:
        this.refs.modifierContainer.scrollTop = this.props.scrollBack;
        break;
    }
  }

  handleChange = () => {
    const { handleModifierChange } = this.props;
    if (handleModifierChange)
      handleModifierChange(
        getSelectedPizzaCreatorModifiers(this.getPizzaMods()),
        this.refs.modifierContainer.scrollTop
      );
  };

  getPizzaMods = () => {
    return get(this.props, 'pizzaCreator.pizza_mods', []);
  };

  getPizzaModType = pizzaMod => {
    return pizzaMod.forced_modifier_list_type === 'choice' &&
      pizzaMod.forced_modifier_list_type !== 'optional'
      ? ModifierInputList.RADIO_TYPE
      : ModifierInputList.CHECKBOX_TYPE;
  };

  render() {
    const pizzaMods = this.getPizzaMods();
    return (
      <div className="row modifier-container" ref="modifierContainer">
        {pizzaMods.map(pizza_mod => (
          <ModifierInputList
            key={pizza_mod.id}
            modifierOptionType={pizza_mod['forced_modifier_list_type_option']}
            title={pizza_mod.name.toUpperCase()}
            type={this.getPizzaModType(pizza_mod)}
            modifiers={pizza_mod.forced_modifiers}
            onChange={this.handleChange}
            partialServingPricing={pizza_mod.partial_serving_pricing}
          />
        ))}
        <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12 spacer" />
      </div>
    );
  }
}

export default PizzaCreatorModifiers;



// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/components/PizzaCreatorModifiers/index.jsx